import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./assets/fonts/Font.css";
import { ModalProvider } from "./context/Modal/ModalContext";
import GlobalModal from "./components/modals/globalModal/GlobalModal";
// import "./index.css";
import "./assets/styles/datepickerStyle.css"; //새로 생성한 datePickerStyles.css 파일

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <ModalProvider>
        <GlobalModal />
        <App />
      </ModalProvider>
    </BrowserRouter>
  </React.StrictMode>
);
